import * as api from 'common/api'
import uniq from 'lodash/uniq'
import groupBy from 'lodash/groupBy'

// 学科列表： [初中英语，初中语文，高中数学]
export let list = () => api.get('configuration/subject/list')
// 根据学科获取年级 初中英语 => 初中
export let getGrade = subject => subject.substring(0, 2)
// 根据学科列表获取年级列表 [初中英语，初中语文，高中数学] => [初中，高中]
export let getGrades = subjects => uniq(subjects.map(getGrade))
// 按年级对学科列表分组 [初中英语，初中语文，高中数学] => {初中：[英语，语文]，高中：[数学]}
export let groupByGrade = subjects => groupBy(subjects, getGrade)



// WEBPACK FOOTER //
// ./src/api/configuration/subject.js